<template>
  <div
    class="time-stripe text-center-mobile flex items-center space-x-2"
  >
    <i class="icon icon-clock-2"></i>
    <div v-if="props.data.date">
      <span class="countdownTimer"><b>{{ props.data.time ? props.data.time : $t('loading') }}</b></span> {{ $t('toShipYourOrder') }}
      <span class="countdownTimerDate">
        <template v-if="props.data.date">
          <b>{{ props.data.date }}</b>
        </template>
        <template v-else>
          {{ $t('loading') }}
        </template>
      </span>
    </div>
    <Skeleton
      v-else
      class="!w-[200px] !h-[1rem]"
    >
    </Skeleton>
  </div>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object, Boolean],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.time-stripe {
  width: 100%;
  padding: .5rem 0;
  font-size: 11px;
  line-height: 1.5;
  border-radius: 60px;

  @media only screen and (max-width: 600px) {
    font-size: 11px;
  }

  &.lg {
    @media only screen and (min-width: 992px) {
      font-size: 1rem;
    }

    [class^="icon-"],
    [class^="icon-"] {
      @media only screen and (min-width: 992px) {
        margin-right: 9px;
        font-size: 24px;
      }
    }

    i {
      @media only screen and (min-width: 992px) {
        font-size: 1.5rem;
      }
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  [class^="icon-"],
  [class^="icon-"] {
    margin-right: .125rem;
    color: #000;
    font-size: .8375rem;

    @media only screen and (min-width: 992px) {
      margin-right: .25rem;
      font-size: 1.1875rem;
    }
  }

  i {
    margin-right: .5rem;
    color: #000;
    font-size: 1.25rem;
    vertical-align: sub;

    @media only screen and (min-width: 992px) {
      font-size: 1.125rem;
    }
  }

  time {
    font-weight: 700;
  }
}
</style>
